import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import { CommonHttpService } from '../commonHttp.service';
import { LoaderService } from '../../_shared/services/loader.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  baseUrl: any = environment.apiUrl;
	Email: any;
	errorMessage: any = '';
  user: any = {};
  success: boolean;

  constructor(private service: CommonHttpService, private router: Router, private route: ActivatedRoute, private loaderService: LoaderService) { }

  ngOnInit() {
  }

  forgotPassword() {
    this.loaderService.display(true);
    this.user.UserName = this.Email;
    this.user.LoginType = "Normal"
  	this.service.create(this.baseUrl + 'LoginAPI/ForgetPasswordEmail', this.user)
      .subscribe(
        data => {
          console.log(data)
          if(data.statusCode == 1){
            this.success = true
          }
          else{
            this.success = false
            this.errorMessage = data.responseMessage
          }
          this.loaderService.display(false);
        },
        (error) => {
          this.loaderService.display(false);
        })
  }

}


// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/forgot-password/forgot-password.component.ts